module.exports = __webpack_public_path__ + "img/19.444bcc4f.jpg";